import { LockedIcon, UnlockedIcon } from '../../../../assets/icons';
import { formatPercentages, formatUSD } from '../../../../helpers';
import { LockPoolDetails } from '../../../../hooks/web3/pools/useUserLockUps';

type DepositOverviewProps = {
    lockPoolDetail: LockPoolDetails;
    showUsdc: boolean;
};

const DepositOverview: React.FC<DepositOverviewProps> = ({
    lockPoolDetail,
    showUsdc,
}) => {
    return (
        <div className='row'>
            <div>
                <span>
                    {lockPoolDetail.lockUp?.duration === undefined
                        ? 'No Lock'
                        : `${lockPoolDetail.lockUp.duration} days`}
                </span>
                <svg className='deposit-overview-line' width='100%' height='1'>
                    <line
                        x1='0'
                        y1='1'
                        x2='100%'
                        y2='1'
                        stroke='rgba(255,255,255,0.5)'
                        strokeDasharray='4'
                    />
                </svg>
            </div>
            <div>
                <span>
                    <span>
                        <UnlockedIcon />{' '}
                        <span className='mobile-label'>
                            {lockPoolDetail.lockUp?.duration === undefined ? (
                                <strong>No Lock</strong>
                            ) : (
                                <>
                                    <strong>{lockPoolDetail.lockUp.duration}d</strong>{' '}
                                    Unlocked
                                </>
                            )}
                        </span>
                    </span>
                    {formatUSD(
                        showUsdc
                            ? lockPoolDetail.unlockedAssets
                            : lockPoolDetail.unlockedLp,
                        {
                            minDecimals: 2,
                            currency: '',
                        }
                    )}{' '}
                    (
                    {formatPercentages(
                        showUsdc
                            ? lockPoolDetail.unlockedAssetsRatio
                            : lockPoolDetail.unlockedLpRatio
                    )}
                    %)
                </span>
                <svg className='deposit-overview-line' width='100%' height='1'>
                    <line
                        x1='0'
                        y1='1'
                        x2='100%'
                        y2='1'
                        stroke='rgba(255,255,255,0.5)'
                        strokeDasharray='4'
                    />
                </svg>
            </div>
            <div>
                <span>
                    <span>
                        <LockedIcon />{' '}
                        <span className='mobile-label'>
                            {lockPoolDetail.lockUp?.duration === undefined ? (
                                <>
                                    <strong>6-hours</strong> Lock
                                </>
                            ) : (
                                <>
                                    <strong>{lockPoolDetail.lockUp.duration}d</strong>{' '}
                                    Locked
                                </>
                            )}
                        </span>
                    </span>
                    {formatUSD(
                        showUsdc ? lockPoolDetail.lockedAssets : lockPoolDetail.lockedLp,
                        {
                            minDecimals: 2,
                            currency: '',
                        }
                    )}{' '}
                    (
                    {formatPercentages(
                        showUsdc
                            ? lockPoolDetail.lockedAssetsRatio
                            : lockPoolDetail.lockedLpRatio
                    )}
                    %)
                </span>
            </div>
        </div>
    );
};

export default DepositOverview;
